// extracted by mini-css-extract-plugin
export default {"register_text":"login_register_text__JAU2u","logoImage":"login_logoImage__eL0yQ","separator":"login_separator__jmEz-","btnLoginGoogle":"login_btnLoginGoogle__YdDu7"};